import { oauthProviderClient } from "@better-auth/oauth-provider/client";
import {
  anonymousClient,
  emailOTPClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

// Better Auth lives on the API under /api/auth. oauthProviderClient forwards the signed
// OAuth query (when this page was opened by an MCP client's authorize request) so that
// signing in continues the OAuth flow.
export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_ENDPOINT as string,
  fetchOptions: { credentials: "include" },
  plugins: [emailOTPClient(), anonymousClient(), oauthProviderClient()],
});

// Where Better Auth wants the browser to go next (e.g. back to the OAuth client).
export function redirectUrl(data: unknown): string | undefined {
  if (data && typeof data === "object" && "url" in data) {
    const { url } = data as { url?: unknown };
    if (typeof url === "string") return url;
  }
  return undefined;
}
